import styled from 'styled-components';

type DocumentContainerProps = {
  offBorders?: boolean;
  offDot?: boolean;
  column?: boolean;
  paddingLeft?: string;
  paddingBottom?: string;
};

export const DocumentCategoriesContainer = styled.div`
  width: 100%;
  display: flex;
  gap: 10px;
  flex-direction: column;
`;

export const DocumentContainerUI = styled.div<DocumentContainerProps>`
  width: 100%;
  padding-top: 20px;
  display: flex;
  justify-content: flex-start;
  flex-direction: ${(props) => (props.column ? 'column' : 'row')};
  gap: 10px;
  padding-bottom: ${(props) => (props.paddingBottom ? props.paddingBottom : '')};

  border-top: ${(props) => (props.offBorders ? '' : '1px solid rgba(56, 72, 91, 0.8)')};

  &:before {
    margin-top: 27px;
    content: '';
    width: 8px;
    height: 6.8px;
    background-color: rgba(56, 72, 91, 0.8);
    border-radius: 1000px;
    display: ${(props) => (props.offDot ? 'none' : 'block')};
  }

  .item {
    color: rgba(56, 72, 91, 0.8);
    font-size: 20px;
    text-align: left;
    width: 100%;
    min-height: 50px;
    padding-top: 20px;
    line-height: 24px;
    position: relative;

    border: 0;
    background: 0;
    cursor: auto;

    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    margin: 0;
    padding-right: 60px;
  }
`;

export const DocumentCollapsableButton = styled.div`
  font-size: 20px;
  width: 35px;
  height: 35px;
  position: absolute;
  border: 1px solid rgba(56, 72, 91, 0.8);
  background: none;
  color: rgba(56, 72, 91, 0.8);

  display: flex;
  justify-content: center;
  align-items: center;

  border-radius: 1000px;

  right: 10px;
  top: 50%;
  transform: translate(0, -50%);
`;

export const FilesContainerUI = styled.div`
  width: 100%;
  padding: 0 20px;
  display: flex;
  justify-content: space-between;

  .right-side,
  .left-side {
    display: flex;
    flex-direction: row;
  }

  .right-side {
    a {
      text-decoration: underline;

      &:hover {
        text-decoration: none;
      }
    }
  }

  .left-side {
    gap: 10px;
    align-items: center;
    padding-right: 25px;
    text-align: justify;
  }

  a {
    color: rgba(56, 72, 91, 0.8);

    &:hover {
      text-decoration: underline;
    }
  }
`;

export const ContentLayout = styled.div`
  margin-top: 20px;
  color: #606d7c;
  font-size: 16px;
  line-height: 22px;
`;
